<template>
  <div class="card shadow-sm mb-4">
    <div class="card-body px-4 pt-3 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="items"
        :columns="columns"
        :total="total"
        :rowKey="rowKey"
        :colgroup="colgroup"
        empty-message="조건에 맞는 접속 이력이 없습니다."
        :usePaging="true"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :minBodyHeight="heights.minBody"
        :minContHeight="heights.minCont"
        :message="'접속이력 조회중...'"
        :minHeight="heights.min"
        :emptyHeight="heights.empty"
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <!-- No. -->
          <td class="text-center text-sm">{{ total - startIndex - index }}</td>

          <!-- 발생일시 -->
          <td class="text-center text-sm" :title="item.creatDt">
            {{ formatDate(item.creatDt) }}
          </td>

          <!-- 사용자 -->
          <td class="text-center text-sm" :title="item.userId || '-'">
            {{ item.userId || '-' }}
          </td>

          <!-- IP -->
          <td class="text-center text-sm" :title="item.ip || '-'">
            {{ item.ip || '-' }}
          </td>

          <!-- 메서드 -->
          <td class="text-center text-sm">
            <CustomBadge :level="methodBadgeClass(item.httpMethod)" size="sm" :label="(item.httpMethod || '').toUpperCase() || '-'" />
          </td>

          <!-- URL -->
          <td class="text-start text-sm" :title="item.url">
            <span class="d-inline-block text-truncate" style="max-width: 360px;">
              {{ item.url }}
            </span>
          </td>
        </template>
      </BaseDataTable>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import api from '@/api/api';

export default {
  name: 'WebLogTable',
  components: { CustomBadge, BaseDataTable },
  props: {
    filters: { type: Object, default: () => ({}) },
    applyTick: { type: Number, default: 0 },
    initPageSize: { type: Number, default: 15 },
    heights: {
      type: Object,
      default: () => ({
        minBody: 780,
        minCont: 780,
        min: 900,
        empty: 680,
      }),
    },
  },
  emits: ['row-click', 'update-stats'],
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: this.initPageSize,
      sort: 'creatDt,desc',
      columns: [
        { label: 'No.' },
        { label: '발생일시', sortable: true, prop: 'creatDt' },
        { label: '사용자',   sortable: true, prop: 'userId' },
        { label: 'IP',       sortable: true, prop: 'ip' },
        { label: '메서드',   sortable: true, prop: 'httpMethod' },
        { label: 'URL',      sortable: true, prop: 'url' },
      ],
      colgroup: [
        'width:9%',
        'width:17%',
        'width:18%',
        'width:15%',
        'width:13%',
        'width:28%',
      ],
      elapsed: '0.00',
    };
  },
  computed: {
    startIndex() { return (this.page - 1) * this.pageSize; },
  },
  watch: {
    applyTick() { this.page = 1; this.fetch(); },
    query() { this.page = 1; this.fetch(); },
    page() { this.fetch(); },
    pageSize() { this.page = 1; this.fetch(); },
  },
  mounted() { 

  },
  methods: {
    rowKey(item, idx) { return item.webLogId || idx; },
    async fetch() {
      if (this.loading) return;
      this.loading = true;
      const started = performance.now();
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const params = {
          mfId,
          page: this.page,
          size: this.pageSize,
          sort: this.sort,
          method: this.filters?.method || '',
          query: this.filters?.query || '',
          timeFrom: this.filters?.timeFrom || '',
          timeTo: this.filters?.timeTo || '',
        };
        const [res] = await Promise.all([
          api.get('/webLog/page', { params }),
          new Promise(r => setTimeout(r, 300)),
        ]);
        const r = res.data?.result || {};
        const items = r.items || res.data?.result?.weblogList?.items || [];
        const total = Number(r.total ?? res.data?.result?.weblogList?.total ?? 0);
        this.items = items;
        this.total = total;

        this.elapsed = ((performance.now() - started) / 1000).toFixed(2);
        this.$emit('update-stats', { total: this.total, elapsed: this.elapsed });
      } catch (e) {
        console.error('접속 이력 조회 실패:', e);
      } finally {
        this.loading = false;
      }
    },
    onRowClick(item) { this.$emit('row-click', item); },
    formatDate(str) {
      if (!str) return '-';
      const d = new Date(str);
      if (isNaN(d)) return str;
      return d.toLocaleString(undefined, { year:'2-digit', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' });
    },
    methodBadgeClass(m) {
      const v = (m || '').toUpperCase();
      if (v === 'GET') return 'bg-secondary';
      if (v === 'POST') return 'bg-success';
      if (v === 'PUT' || v === 'PATCH') return 'bg-warning';
      if (v === 'DELETE') return 'bg-danger';
      return 'bg-dark';
    },
  },
};
</script>
